import { Cookies } from 'react-cookie';
import {
    CUSTOM_FIELD_RESET,
    CUSTOM_FIELD_FOCUS,
    CUSTOM_FIELD_DOWNLOADED,
    CUSTOM_FIELDS_DOWNLOADED,
    CUSTOM_FIELDS_PENDING,
    CUSTOM_FIELDS_FAILED,
    CUSTOM_FIELD_FAILED,
    CUSTOM_FIELD_POSTING,
    CUSTOM_FIELD_EDITING,
    CUSTOM_FIELD_DELETING,
    CUSTOM_FIELDS_RESET,
    CUSTOM_FIELD_DELETED,
} from './types';
import APIService from '../../services/api';
import { handleError } from '../infos/actions';

const cookies = new Cookies();

// Action creators

export const resetCustomFieldAction = () => {
    return { type: CUSTOM_FIELD_RESET };
};

export const resetCustomFieldsAction = () => {
    return { type: CUSTOM_FIELDS_RESET };
};

export const customFieldsPendingAction = () => {
    return { type: CUSTOM_FIELDS_PENDING };
};

export const customFieldPostingAction = () => {
    return { type: CUSTOM_FIELD_POSTING };
};

export const customFieldDeletedAction = (id) => {
    return {
        type: CUSTOM_FIELD_DELETED,
        payload: id,
    };
};

export const customFieldDeletingAction = () => {
    return { type: CUSTOM_FIELD_DELETING };
};

export const customFieldEditingAction = () => {
    return { type: CUSTOM_FIELD_EDITING };
};

export const customFieldsDownloadedAction = (customFields) => {
    return {
        type: CUSTOM_FIELDS_DOWNLOADED,
        payload: customFields,
    };
};

export const customFieldDownloadedAction = (customField) => {
    return {
        type: CUSTOM_FIELD_DOWNLOADED,
        payload: customField,
    };
};

export const customFieldFocusAction = (customField) => {
    return {
        type: CUSTOM_FIELD_FOCUS,
        payload: customField,
    };
};

// Actions

export function resetCustomField() {
    return (dispatch) => {
        dispatch(resetCustomFieldAction());
    };
}

export function resetCustomFields() {
    return function (dispatch) {
        dispatch(resetCustomFieldsAction());
    };
}

export function getCustomFields(appId) {
    return function (dispatch) {
        dispatch(customFieldsPendingAction());
        return APIService
            .getCustomFields(appId, cookies.get('token'))
            .then(customFields => {
                dispatch(customFieldsDownloadedAction(customFields));
            })
            .catch((error) => {
                dispatch(handleError(error, CUSTOM_FIELDS_FAILED));
            });
    };
}

export function fetchCustomField(appId, customFieldId) {
    return function (dispatch, getState) {
        let customFields = getState().customFields.content;
        let customField = customFields
            ? customFields.find(function (customField) {
                return customField.id === customFieldId;
            })
            : null;

        if (customField) {
            return dispatch(customFieldFocusAction(customField));
        } else {
            return dispatch(getCustomField(appId, customFieldId));
        }
    };
}

export function getCustomField(appId, customFieldId) {
    return function (dispatch) {
        dispatch(customFieldsPendingAction());
        return APIService
            .getCustomField(appId, customFieldId, cookies.get('token'))
            .then(customField => {
                dispatch(customFieldDownloadedAction(customField));
            })
            .catch((error) => {
                dispatch(handleError(error, CUSTOM_FIELD_FAILED));
            });
    };
}

export function postCustomField(appId, customField) {
    return function (dispatch) {
        dispatch(customFieldPostingAction());
        return APIService
            .postCustomField(appId, customField, cookies.get('token'))
            .then(customField => {
                dispatch(customFieldDownloadedAction(customField));
            })
            .catch((error) => {
                dispatch(handleError(error, CUSTOM_FIELD_FAILED));
            });
    };
}

export function putCustomField(appId, customField) {
    return function (dispatch) {
        dispatch(customFieldEditingAction());
        return APIService
            .putCustomField(appId, customField, cookies.get('token'))
            .then(customField => {
                dispatch(customFieldDownloadedAction(customField));
            })
            .catch((error) => {
                dispatch(handleError(error, CUSTOM_FIELD_FAILED));
            });
    };
}

export function deleteCustomField(appId, customFieldId) {
    return function (dispatch) {
        dispatch(customFieldDeletingAction());
        return APIService
            .deleteCustomField(appId, customFieldId, cookies.get('token'))
            .then(() => {
                dispatch(customFieldDeletedAction(customFieldId));
            })
            .catch((error) => {
                dispatch(handleError(error, CUSTOM_FIELD_FAILED));
            });
    };
}




// WEBPACK FOOTER //
// src/store/customfields/actions.js